//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DisparityTag from './DisparityTag.vue'
import AssignmentActions from './AssignmentActions.vue'
export default {
  name: 'SupervisorValidationTable',
  components: {
    DisparityTag,
    AssignmentActions,
  },
  props: {
    collaborators: {
      type: Array,
      default: () => [],
    },
    entity: {
      type: Object,
      default: () => ({
        id: 0,
        name: 'occupationName',
        type: 'occupation',
      }),
    },
  },
  data() {
    return {
      sortableColumns: {
        collaborator_match: 'asc',
        supervisor_match: 'asc',
        disparity: 'asc',
      },
    }
  },
  methods: {
    handleSort(field, order) {
      this.sortableColumns[field] = order
    },
    findSkillsValidated(supervisorAssignment) {
      this.$emit('handleSkillsValidations', supervisorAssignment)
    },
  },
}
